// extracted by mini-css-extract-plugin
export default {"meshbotTypeCell":"styles_meshbotTypeCell__+n5zj"};